
import "./style.css";
import React, {useState, useEffect} from 'react';
import { Grid, Typography, Button, Dialog, LinearProgress, DialogTitle, DialogContent, DialogContentText, DialogActions, Box, Card, CardContent,FormControlLabel, CardActions, Switch, Checkbox, MenuItem, Paper, TableContainer, Table, TableHead, TableCell, TableBody, TableRow } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PIList from '../../PIList';
import TextField from '@mui/material/TextField'; 
import {useNavigate} from "react-router-dom";
import Select from '@mui/material/Select'
import {read} from "../../PaidInvoiceList/api.js";
import {readEmpty} from "../../PaidInvoiceList/apiEmpty.js";
import CloseIcon from '@mui/icons-material/Close';
import axios from "axios";

const NewPIPopUp = (props) => {
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
    const [fileURL, setFileURL] = useState("");
    const handleClosePreview = (event) =>{
      setPreviewVisibility(false)
      setCurrPreview("none")
    }
    const history = useNavigate();
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const [skip, setSkip] = useState(0)
    const [searchThis, setsearchThis] = useState("billTo")
    const [query,setQuery] = useState("")
    const newFetchPosts = async (event) => {}
    async function newPI(e){
    }
    const handleSearch = (event) =>{
      setQuery(event.target.value)
      setSkip(0)
      newFetchPosts(event)
    }
    useEffect(() => {
      fetchPosts();
  }, [skip,query]);
    const fetchPosts = async () => {
      if(query.trim()){
              try{
                  const { data, error } = await read(skip,query,searchThis);
                  if(error){
                      console.log(error.message);
                      return;
                  }
      
                  if(data?.length === 0){
                      setIsEnd("Selesai...");
                      return;
                  }
                  
                  //success
                  setPosts([...posts, ...data])
              }catch(error){
                  console.log(error.message);
              }
          
      }else{

      try{
          const { data, error } = await readEmpty(skip,query);
          if(error){
              console.log(error.message);
              return;
          }

          if(data?.length === 0){
              setIsEnd("Selesai...");
              return;
          }
          
          //success
          setPosts([...posts, ...data])
      }catch(error){
          console.log(error.message);
      } 
      }
  }
    const searchSelected = async (event)=>{
      setsearchThis(event.target.value)
    }

    const handlePackageClick = (index) => {
        setSelectedPackage(index);
      };

      const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const currid = post._id
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/previewpdfpaid?currid=${currid}&dbwhatToPreview=proformainvoiceDB`,{
            method: "GET",
            responseType: "blob"
        }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const handleScroll = () => {

    }
    const [state, setState] = useState({
      gilad: false,
      jason: false,
      antoine: true,
    });
    const [error,setError] = useState(null)
    const checkpaket = (event) =>{
      if(props.selectedPost.packageTitle !== "Virtual Office" && props.selectedPost.packageTitle !== "Call Center"){
        props.nextButton({...props.selectedPost})
      }else{
        setError(props.selectedPost.packageTitle + " harus payment dahulu")
      }      
    }
    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    const [status,setStatus] = useState("No")
    const switchChange = (event) => {
      setState({
        ...state,
        [event.target.name]: event.target.checked,
      });
      if(status === "No"){
        setStatus("Yes")
      }else{
        setStatus("No")
      }
    }
    const linkInvoice = (event) =>{
      props.setContractData({...props.contractData, PaidInvoiceList: [currPreview._id]});
      props.newPIClose()
    }
    

      const renderPackageCard = (index, title, disabled = false) => (
        <Card
          onClick={disabled ? null : () => handlePackageClick(index)}
          sx={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            borderColor: selectedPackage === index ? 'primary.main' : 'divider',
            borderWidth: 1,
            borderStyle: 'solid',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: disabled ? 'action.disabledBackground' : 'background.paper',
            opacity: disabled ? 0.5 : 1,
          }}
        >
          <CardContent>
            <Typography variant="h5">{title}</Typography>
          </CardContent>
          {selectedPackage === index && !disabled && (
            <CardActions>
              <CheckCircleOutlineIcon color="primary" />
            </CardActions>
          )}
        </Card>
      );
    return (<Grid>
    <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
    </Dialog>
    <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="1200" height="500"></iframe>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={linkInvoice}>
                        Hubungkan dengan Invoice ini
                    </Button>
                    </DialogActions>
                </Dialog>
   
    <Grid container sm={{mt:5}}>
      <Grid item xs={2}>
        <Select  fullWidth value={searchThis} onChange={event => searchSelected(event)}><MenuItem value="billTo">Company</MenuItem><MenuItem value="shipTo">PIC</MenuItem><MenuItem value="piAmount">No. PI</MenuItem></Select>
      </Grid>
      <Grid item xs={8}>
        <TextField value={query} onChange={event => handleSearch(event)} fullWidth />
      </Grid>


      <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 500, minHeight: 440 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 200 }}>
                                                    Tanggal
                                                </TableCell>
                                                <TableCell>
                                                    Bill To (Company)
                                                </TableCell>
                                                <TableCell>
                                                    Bill To (PIC)
                                                </TableCell>
                                                <TableCell>
                                                    Nomor PI
                                                </TableCell>
                                                <TableCell style={{ width: 25 }}>
                                                </TableCell>
                                                <TableCell style={{ width: 25 }}>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.tanggalPI}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.billTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.shipTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.piAmount}</p>
                                                    </TableCell>
                                                    <TableCell>
                                                    
                                                    </TableCell>
                                                    <TableCell>
                                                        
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>

    </Grid>
    {error && <div className="error_text">{error}</div>}
    
    </Grid>);};

    export default NewPIPopUp;
